import { DepartmentModel } from 'api/dto/Department.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'department';

export namespace DepartmentState {
  export type ListResource = Resource<DepartmentModel[]>;

  export type Domain = {
    listResource: ListResource;
    dryListResource: ListResource;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource<DepartmentModel[]>(),
    dryListResource: Resource.createResolvedResource<DepartmentModel[]>({ data: [] }),
  };
}
